import { PawPrint } from "lucide-react";
import { MARQUEE_ITEMS } from "@/lib/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative z-10 overflow-hidden border-y border-gold/25 bg-gold py-3.5">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} aria-hidden={i >= MARQUEE_ITEMS.length} className="flex items-center gap-10 font-mono text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-charcoal">
            {item}
            <PawPrint className="h-4 w-4" />
          </span>
        ))}
      </div>
    </div>
  );
}
